var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.148,64.379h-1.572V47.566c0-0.794-0.47-1.513-1.197-1.832l-8.622-3.778v-5.4c0.05,0.004,0.099,0.023,0.148,0.023 c0.62,0,1.232-0.288,1.623-0.829c0.646-0.896,0.445-2.146-0.45-2.792L49.171,21.464c-0.698-0.505-1.643-0.505-2.342,0 L30.921,32.958c-0.896,0.647-1.097,1.897-0.45,2.792c0.423,0.584,1.102,0.867,1.771,0.817v5.388l-8.622,3.778 c-0.728,0.319-1.197,1.038-1.197,1.832v16.813h-1.573c-1.104,0-2,0.896-2,2s0.896,2,2,2h13.392h9.307h8.902h9.306h13.392 c1.104,0,2-0.896,2-2S76.253,64.379,75.148,64.379z M69.576,48.873v15.506h-5.819V46.324L69.576,48.873z M26.424,48.873 l5.819-2.549v18.055h-5.819V48.873z M45.549,64.379v-13.07h4.902v13.07H45.549z M54.451,64.379v-15.07c0-1.104-0.896-2-2-2h-8.902 c-1.104,0-2,0.896-2,2v15.07h-5.307V43.244c0-0.004,0-0.008,0-0.011v-9.184L48,25.553l11.757,8.495v9.185c0,0.003,0,0.007,0,0.01 v21.136H54.451z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.451,34.902H50v-2.451c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.451h-2.451c-1.104,0-2,0.896-2,2s0.896,2,2,2H46v2.451 c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.451h2.451c1.104,0,2-0.896,2-2S53.556,34.902,52.451,34.902z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.e6b5b7d086f4026c2ed32991022d7347.svg";
export { ForwardRef as ReactComponent };